import { useMemo } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { MenuList, Option } from './components';
import { getPeriodOptions } from './utils';
import s from './index.module.scss';

export const PeriodSelect = ({ range, onChange }) => {
  const { t } = useTranslation('activity');
  const options = getPeriodOptions(t);

  const current = useMemo(() => {
    const period = range.join(':');
    return options?.find(option => option.value === period) || null;
  }, [range, options]);

  const handleChange = option => {
    const range = option.value.split(':');
    onChange(range);
  };

  return (
    <div className={s.wrapper}>
      <div className="f-small-accent">{t('date_picker.period')}</div>
      <Select
        value={current}
        onChange={handleChange}
        className={s.select}
        classNamePrefix="period"
        name="period"
        isSearchable={false}
        options={options}
        components={{ Option, MenuList }}
        placeholder={t('date_picker.custom')}
      />
    </div>
  );
};
